import { useTranslation } from 'react-i18next'
import type { QuickSuggestionProps } from '@brochure/shared'

export function QuickSuggestions({
  suggestions,
  onSelect,
  disabled,
}: QuickSuggestionProps) {
  const { t } = useTranslation('common')

  return (
    <div className="flex flex-wrap gap-1.5 justify-center">
      {suggestions.map((suggestion) => (
        <button
          key={suggestion.id}
          onClick={() => onSelect(suggestion.messageKey)}
          disabled={disabled}
          className="px-3 py-1.5 text-[12px] font-medium bg-white hover:bg-brand-50 text-ink-700 hover:text-brand-700 rounded-sm transition-colors disabled:opacity-50 border border-ink-200 hover:border-brand-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-300"
        >
          {t(suggestion.labelKey)}
        </button>
      ))}
    </div>
  )
}
